{
    "Accessibility menu": "Menú de accesibilidad",
    "Reset settings": "Restablecer Configuración",
    "Close": "Cerrar",
    "Content adjustments": "Ajustes de Contenido",
    "Navigation adjustments": "Ajustes de Navegación",
    "Align Left": "Alinear a la Izquierda",
    "Adjust Font Size": "Ajustar Tamaño de Fuente",
    "Highlight Title": "Resaltar Título",
    "Highlight Links": "Resaltar Enlaces",
    "Readable Font": "Fuente Legible",
    "Colour adjustments": "Ajustes de Color",
    "Dark Contrast": "Contraste Oscuro",
    "Light Contrast": "Contraste Claro",
    "High Contrast": "Alto Contraste",
    "High Saturation": "Alta Saturación",
    "Low Saturation": "Baja Saturación",
    "Monochrome": "Monocromo",
    "Tools": "Herramientas",
    "Reading Guide": "Guía de Lectura",
    "Stop Animations": "Detener Animaciones",
    "Big Cursor": "Cursor Grande",
    "Increase Font Size": "Aumentar Tamaño de Fuente",
    "Decrease Font Size": "Disminuir Tamaño de Fuente",
    "Letter Spacing": "Espaciado entre Letras",
    "Line Height": "Altura de Línea",
    "Font Weight": "Peso de Fuente",
    "Dyslexia Font": "Fuente para Dislexia",
    "Language": "Idioma",
    "Accessibility widget": "Abrir menú de accesibilidad",
    "Accessibility Profiles": "Perfiles de Accesibilidad",
    "Cognitive Disability": "Discapacidad Cognitiva",
    "Seizure Safe": "Seguro para Epilepsia",
    "Accessibility statement": "Declaración de Accesibilidad"
}